var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgInstagram = function SvgInstagram(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_589)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2780_589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60608 0.00391155C9.70508 0.00391155 10.8041 1.478e-06 11.9031 0.00391155C14.1676 0.0156418 16.0409 1.54057 16.4985 3.75758C16.565 4.07429 16.5924 4.40274 16.5924 4.72727C16.6002 6.913 16.6002 9.09873 16.5963 11.2845C16.5885 13.564 15.0593 15.4487 12.8417 15.9023C12.521 15.9687 12.1847 15.9961 11.8522 15.9961C9.68553 16.0039 7.51882 16 5.35211 16C2.95074 15.9961 1.03825 14.3656 0.654969 11.9922C0.61977 11.7693 0.604125 11.5386 0.604125 11.3118C0.600214 9.10655 0.596303 6.90127 0.604125 4.69599C0.611947 2.43206 2.14116 0.559141 4.35871 0.101663C4.67941 0.0351921 5.01576 0.0117317 5.3482 0.00782161C6.43155 -0.00390859 7.51882 0.00391155 8.60608 0.00391155ZM8.61391 4.00391C6.40809 3.99218 4.61684 5.77517 4.6051 7.98436C4.59728 10.1896 6.37289 11.9805 8.58653 11.9922C10.7923 12.0039 12.5836 10.2209 12.5953 8.01173C12.6032 5.80645 10.8275 4.01564 8.61391 4.00391ZM13.929 3.34311C13.9329 2.97556 13.6318 2.67058 13.2641 2.67058C12.8965 2.67058 12.5953 2.97556 12.5953 3.3392C12.5992 3.69893 12.8926 3.99609 13.2524 4.00391C13.62 4.01173 13.9251 3.71066 13.929 3.34311Z",
    fill: "#1E2A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61363 5.33724C10.092 5.34115 11.2692 6.53372 11.2614 8.01564C11.2536 9.49365 10.0568 10.6706 8.57843 10.6588C7.10788 10.6471 5.93458 9.46236 5.93849 7.98827C5.9424 6.51417 7.13135 5.33333 8.61363 5.33724Z",
    fill: "#1E2A33"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.600098)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2780_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.600098)"
  })))));
};
export { SvgInstagram as ReactComponent };
export default __webpack_public_path__ + "static/media/instagram.86b8397b.svg";